export const PLAN_CONFIG = {
    requests: {
        getPlanProduction: {
            url: `plan/productions`,
        },
        getPlanChangeReasons: {
            url: `plan/plan-change-reasons`,
        },
        getPlanSale: {
            url: `plan/sales`,
        },
        getPlanDistribution: {
            url: `plan/distributions`,
        },
        getPlanDelivery: {
            url: `plan/deliveries`,
        },
        getPlanCampaigns: {
            url: `plan/inspections`,
        },
        getPlanDelvieryDoc: {
            url: `plan/deliveryDocs`,
        },
    },
};
